import classNames from 'classnames';
import Headline from 'src/helpers/Headline/Headline';
import { Subheadline } from 'src/helpers/Subheadline';
import ButtonGroup from 'src/helpers/ButtonGroup/ButtonGroup';
import LinkWrapper from 'src/helpers/LinkWrapper/LinkWrapper';
import TimeCard from './TimeCard.helper';
import { cta1ToButtonProps, cta2ToButtonProps } from 'src/helpers/Button';
import { CallTrackingConstants } from 'lib/constants/call-tracking';

type ShowroomLocationMarkupProps = {
  // we can ignore below type error for type Any, as type of value in those object parameters are uncertain
  /* eslint-disable @typescript-eslint/no-explicit-any */
  templateClasses: { [property: string]: any };
  renderingFields: any;
  /* eslint-enable @typescript-eslint/no-explicit-any */
};

const ShowroomLocationMarkup = ({
  templateClasses,
  renderingFields,
}: ShowroomLocationMarkupProps) => {
  return (
    <div
      className={classNames(
        'group relative  w-full ',
        templateClasses?.gridItem,
        CallTrackingConstants.showroomPhoneNumberClass
      )}
    >
      <Headline classes={templateClasses?.headline} {...renderingFields.showroomName} />
      <Subheadline
        classes={classNames(templateClasses?.subheadline, '!mb-0')}
        {...renderingFields.showroomAddressLine1}
      />
      <Subheadline
        classes={classNames(templateClasses?.subheadline, '!mb-0')}
        {...renderingFields.showroomAddressLine2}
      />
      <Subheadline
        classes={templateClasses?.subheadline}
        {...renderingFields.showroomLocationWithPostal}
      />

      <LinkWrapper
        ctaSection="header"
        className={classNames(
          templateClasses?.subheadline,
          'w-fit hover:underline',
          CallTrackingConstants.showroomPhoneNumberClass
        )}
        field={{
          href: `tel: ${renderingFields?.showroomLocationPhoneNumber}`,
          text: renderingFields?.showroomLocationPhoneNumber,
        }}
      />

      {/* Showroom Hours Time-Card */}
      <TimeCard
        showroomHours={renderingFields?.showroomHours}
        classes={templateClasses?.showroomHours?.showrooms}
        title="Showroom Hours"
      />

      <ButtonGroup
        cta1={cta1ToButtonProps(
          renderingFields.showroomPageUrl,
          templateClasses?.buttonGroup?.cta1Classes
        )}
        cta2={cta2ToButtonProps(
          renderingFields.showroomPageUrl,
          templateClasses?.buttonGroup?.cta2Classes
        )}
        wrapperClasses={templateClasses?.buttonGroup.wrapper}
      />
    </div>
  );
};

export default ShowroomLocationMarkup;
